import React from "react";
import { NewConventionModal } from "./components";
import { useHandlers } from "./hooks";
import { Button } from "../../../../../../components";

/**
 * @desc Button for creating a new convention.
 */
export const ButtonNewConvention = () => {
  // HANDLERS -----------------------------------------------------------------

  const { handleClick } = useHandlers();

  // COMPONENT ----------------------------------------------------------------

  const props = {
    children: "Create New",
    onClick: handleClick,
  };

  return (
    <>
      <NewConventionModal />
      <Button {...props} />
    </>
  );
};
